<mat-card  appearance="outlined" [ngClass]="(templateRefFooter ? '' : 'no-border-bottom no-actions-space')">
  <mat-card-header>
    @if(tittle){
      <mat-card-title>
        {{tittle}}
      </mat-card-title>
    }
      <div class="grid grid-cols-2 gap-2">
        <ng-container *ngTemplateOutlet="templateRefHeader"></ng-container>
      </div>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngTemplateOutlet="templateRefContent"></ng-container>
  </mat-card-content>
  @if(templateRefFooter){
    <mat-card-actions class="grid grid-2 gap-2">
      <ng-container *ngTemplateOutlet="templateRefFooter">
      </ng-container>
    </mat-card-actions>
  }
</mat-card>
